import { ColorId } from '@verify/shared-utils';
import { Difference, StoreState } from 'types';

/** Stable Prep-tab fallbacks so useSelector does not get new references each call.
 *  arrays and objects always return new references.
 */
export const PREP_EMPTY_DIFFERENCE_GROUPS: Difference[] = [];
export const PREP_EMPTY_STATUS_FILTERS: Record<string, boolean> = {};
export const PREP_DEFAULT_OCR = { sourceIsOCR: false, targetIsOCR: false };

export const selectPrepDifferenceGroups = (_state: StoreState) => PREP_EMPTY_DIFFERENCE_GROUPS;
export const selectPrepFocusedDifference = (_state: StoreState) => undefined;
export const selectPrepIsSingleFile = (_state: StoreState) => false;
export const selectPrepIsOCR = (_state: StoreState) => PREP_DEFAULT_OCR;
export const selectPrepSelectedModule = (_state: StoreState) => 'All' as const;
export const selectPrepDifferenceStatusFilters = (_state: StoreState) => PREP_EMPTY_STATUS_FILTERS;
export const selectPrepHighlightColor = (_state: StoreState) => null as ColorId | null;
